/* Lazysizes */
import "lazysizes"

/* Alpine bootup */

import Alpine from 'alpinejs';
// import AutoAnimate from '@marcreichel/alpine-auto-animate';
// import focus from '@alpinejs/focus';
// import intersect from '@alpinejs/intersect'
// import persist from '@alpinejs/persist'
import collapse from '@alpinejs/collapse'
import { tns } from "tiny-slider/src/tiny-slider";
import flatpickr from "flatpickr";
import { Danish } from "flatpickr/dist/l10n/da.js"

flatpickr.localize(Danish)

window.tns = tns
window.flatpickr = flatpickr

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    // do alpine stuff here
})


Alpine.plugin(collapse);

Alpine.start();

